import { render, staticRenderFns } from "./SelectUnit.vue?vue&type=template&id=5788af6e&scoped=true&"
import script from "./SelectUnit.vue?vue&type=script&lang=js&"
export * from "./SelectUnit.vue?vue&type=script&lang=js&"
import style0 from "./SelectUnit.vue?vue&type=style&index=0&id=5788af6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5788af6e",
  null
  
)

export default component.exports